<template>
  <div>
    <div v-if="ready">
      <b-form :id="`gap-history-form-${_uid}`" @submit.stop.prevent="patchCreateTranche($event)">
        <!-- Updated At -->
        <b-form-group label="Date" label-cols="2">
          <date-picker v-model="gapHistory.updatedAt"
                        :config="config"
                        placeholder="JJ/MM/AAAA"
                        required
                        class="gap-history-date-picker"
                        :disabled="!isAdmin() && !isAgent()">
          </date-picker>
        </b-form-group>

        <!-- Agent -->
        <b-form-group label="Agent" label-cols="2">
          <b-form-select v-model="gapHistory.agent" :id="`gap-history-agent-${_uid}`" :disabled="!isAdmin() && !isAgent()">
              <option v-for="(user, index) in agents" :value="user" :key="index">{{ user.firstName !== null ? user.firstName : 'NR' }} {{ user.lastName !== null ? user.lastName : 'NR' }}
              </option>
          </b-form-select>
        </b-form-group>

        <!-- Gaps -->
        <b-form-group label="Liste des aléas" :id="`gap-history-gaps-group-${_uid}`">
            <b-form-checkbox-group v-model="gapSelected"
                                   name="flavour2"
                                   :options="gapOptions"
                                   id="gapCheckboxes"
                                   :disabled="!isAdmin() && !isAgent()">
            </b-form-checkbox-group>
        </b-form-group>

        <b-form-group>
          <div id="gapHistoryTypeButtons">
          <DeleteConfirmButton
                  v-if="!isNew() && (isAdmin() || isAgent())"
                  :is-modal="false"
                  style="float: right;margin: 11px"
                  message="Supprimer l'aléa"
                  title="Supprimer l'aléa"
                  @confirmed="archiveGapHistory()"
                  @canceled="closeArchiveGapHistory()"/>

          <b-button type="submit"
                    variant="primary"
                    style="float: right;margin: 11px"
                    :form="`gap-history-form-${_uid}`"
                    id="save"
                    v-if="isAdmin() || isAgent()"><svg id="savePicto" viewBox="0 0 24.42 20" style="enable-background:new 0 0 24.42 20;" xml:space="preserve"><path class="st3" d="M24.15,6.71c-0.31-0.41-0.85-0.67-1.41-0.67h-1.31V3.82c0-0.9-0.71-1.63-1.58-1.63h-8.99l-1.3-1.85
		C9.42,0.13,9.17,0,8.91,0H1.72C0.81,0,0.07,0.74,0.07,1.65v16.33c-0.13,0.44-0.08,0.91,0.17,1.3C0.53,19.73,1.04,20,1.61,20h16.95
		c1.14,0,1.44-0.91,1.59-1.35l4.2-10.73C24.48,7.5,24.41,7.06,24.15,6.71z M8.48,1.62l1.3,1.85c0.15,0.22,0.4,0.34,0.66,0.34l9.36,0
		v2.22H5.8c-1.13,0-1.47,1.01-1.59,1.35L1.7,13.78L1.72,1.62H8.48z M18.62,18.09c-0.05,0.14-0.08,0.23-0.11,0.28l-16.88,0L5.73,7.94
		C5.78,7.79,5.82,7.7,5.85,7.66h16.87L18.62,18.09z"/><path class="st3" d="M11.64,17.19c0.07,0.08,0.16,0.13,0.26,0.18c0.1,0.04,0.2,0.06,0.31,0.06c0.11,0,0.21-0.02,0.31-0.06
		c0.1-0.04,0.19-0.1,0.26-0.18l2.29-2.29c0.32-0.32,0.32-0.83,0-1.15c-0.32-0.32-0.83-0.32-1.15,0l-0.91,0.91V9.42
		c0-0.45-0.36-0.81-0.81-0.81c-0.45,0-0.81,0.36-0.81,0.81v5.23l-0.94-0.94c-0.32-0.32-0.83-0.32-1.15,0
		c-0.32,0.32-0.32,0.83,0,1.15L11.64,17.19z"/></svg>Sauvegarder</b-button>
        </div>
        </b-form-group>
      </b-form>
    </div>
    <div v-else>Merci de patienter...</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Clone from 'clone';
import EnumerationService from '../../services/EnumerationService';

const $ = require('jquery');

const getDefaultGapHistory = () => ({
  updatedAt: null,
  agent: null,
  gaps: [],
});

const moment = require('moment');

export default {
  name: 'GapHistoryType',
  props: {
    title: {
      type: String,
      default: 'Nouvel état d\'écarts',
    },
    id: null,
    tranche: null,
  },
  data() {
    return {
      gapSelected: [],
      gapHistory: getDefaultGapHistory(),
      ready: false,
    };
  },
  computed: {
    ...mapGetters({
      userSession: 'getUserSession',
    }),
    config() {
      const size = this.getViewPortSize();
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: moment.locale('fr'),
        focusOnShow: false,
        ignoreReadonly: true,
        allowInputToggle: true,
        widgetPositioning: {
          horizontal: ['sm', 'xs'].indexOf(size) !== -1 ? 'right' : 'left',
        },
      };
    },
    gapOptions() {
      if (this.getGaps() === null || typeof this.getGaps === 'undefined') {
        return [];
      }
      return this.getGaps().map(g => ({ text: `${g.code}`, value: g.id }));
    },
    agents() {
      if (this.getUsers() === null || typeof this.getUsers() === 'undefined') {
        return [];
      }
      return this.getUsers().filter(c => (c.roles.indexOf('ROLE_AGENT') !== -1 || c.roles.indexOf('ROLE_ADMIN') !== -1));
    },
  },
  methods: {
    ...mapGetters([
      'getTrancheStatusEnumeration',
      'getUsers',
      'getEnedisCaseOnGoing',
      'getGaps',
      'getViewPortSize',
      'isAdmin',
      'isAgent',
    ]),
    patchCreateTranche(event) {
      this.ready = false;
      this.gapHistory.updatedAt = moment(this.gapHistory.updatedAt, 'DD/MM/YYYY');

      if (this.isNew()) {
        let payload = {
          agent: this.gapHistory.agent.id,
          gaps: this.gapSelected,
          updatedAt: this.gapHistory.updatedAt.format('YYYY-MM-DD HH:mm:ss')
        };

        axios({
          url: `gaps/histories/${this.tranche.id}`,
          method: 'post',
          data: payload
        })
        .then((response) => {
          this.$store.commit('setTrancheStatusEnumeration', EnumerationService.getEnum(response.data._embedded.tranche_status_enumeration));
          this.$store.commit('setEnedisCaseOnGoing', response.data);

          // Show success toast
          const toast = {
            show: true,
            message: 'Aléa créé avec succès !',
            variant: 'success',
            duration: 3000,
          };

          this.$store.commit('setGlobalToaster', toast);
        })
        .catch((error) => {
          console.error(error.message);
        })
        .finally(() => {
          this.$emit('gapHistoryTypeJobEnded');
        });
      } else {
        let payload = {
          agent: this.gapHistory.agent.id,
          gaps: this.gapSelected,
          updatedAt: this.gapHistory.updatedAt.format('YYYY-MM-DD HH:mm:ss'),
          archived: this.gapHistory.archived,
        };

        axios.patch(`gaps/histories/${this.gapHistory.id}`, payload)
            .then((response) => {

              // Show success toast
              const toast = {
                show: true,
                message: 'Aléa modifié avec succès !',
                variant: 'success',
                duration: 3000,
              };

              this.$store.commit('setGlobalToaster', toast);
              this.$store.commit('setEnedisCaseOnGoing', response.data);
            })
            .catch((error) => {
              console.error(error.message);
            })
            .finally(() => {
              this.$emit('gapHistoryTypeJobEnded');
            });
      }
    },
    archiveGapHistory() {
      if (this.isNew()) {
        return;
      }

      let payload = {
        archived: true,
      };

      axios.patch(`gaps/histories/${this.gapHistory.id}`, payload)
          .then((response) => {

            // Show success toast
            const toast = {
              show: true,
              message: 'Aléa supprimé avec succès !',
              variant: 'success',
              duration: 3000,
            };

            this.$store.commit('setGlobalToaster', toast);
            this.$store.commit('setEnedisCaseOnGoing', response.data);
          })
          .catch((error) => {
            console.error(error.message);
          })
          .finally(() => {
            this.$emit('gapHistoryTypeJobEnded');
          });
    },
    closeArchiveGapHistory() {
      this.$emit('gapHistoryTypeJobEnded');
    },
    isNew() {
      return typeof this.id === 'undefined';
    },
  },
  beforeMount() {
    this.$store.dispatch('getUsers').finally();
  },
  mounted() {
    if (this.isNew()) {
      this.gapHistory.agent = this.userSession;
      this.gapHistory.updatedAt = moment(new Date()).format('DD/MM/YYYY');
    } else {
      axios.get(`gaps/histories/${this.id}`)
        .then((response) => {
          this.gapHistory = response.data;
          if (this.gapHistory.updatedAt !== null && typeof this.gapHistory.updatedAt !== 'undefined') {
            this.gapHistory.updatedAt = moment(this.gapHistory.updatedAt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
          }
          this.gapSelected = this.gapHistory.gaps.map(g => g.id);
          this.ready = true;
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
    // Get the gap list from server
    axios.get('gaps')
          .then((response) => {
            this.$store.commit('setGaps', response.data);
          })
          .catch((error) => {
            console.error(error.message);
          })
          .finally(() => {
            if (this.isNew()) {
              this.ready = true;
            }
          });

    // Set input date time picker to readonly because of the keyboard mobile event
    $('.tranche-ameo-date-group-input input').attr('readonly', 'readonly');
  },
  destroyed() {
    // console.log('destroyed gh type : ');
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#save {
  background-color: #005EB8;
  border-color: #005EB8;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
  padding: 10px 30px;
  display: flex;
  flex-direction: row;
  align-items: center;

  #savePicto {
    fill: white;
    width: 19px;
    margin-right: 10px
  }

  &:hover,
  &:focus,
  &:active {
    background-color: white;
    color: #005EB8;

    #savePicto {
      fill: #005EB8 !important;
    }
  }
}

#gapHistoryTypeButtons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/form/GapHistoryType.vue